import { render, staticRenderFns } from "./ReportList.vue?vue&type=template&id=efac9f32&scoped=true"
import script from "./ReportList.vue?vue&type=script&lang=js"
export * from "./ReportList.vue?vue&type=script&lang=js"
import style0 from "./ReportList.vue?vue&type=style&index=0&id=efac9f32&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efac9f32",
  null
  
)

export default component.exports